import { InMemoryCache } from '@websolutespa/payload-plugin-bowl';
import { ResponseSuccess } from '@websolutespa/payload-utils/server';
import { PayloadHandler, PayloadRequest } from 'payload';
import { fetchRobot } from '../utils/robot';
import { errorHandler } from './error.handler';
import { RobotEndpointPostProcessor } from './types';

const CACHE_ = new InMemoryCache<RobotEndpointPostProcessor[]>();

export const endpointPostProcessorsHandler: PayloadHandler = async (req: PayloadRequest) => {
  try {
    let postProcessors: RobotEndpointPostProcessor[];

    const cacheKey = 'endpoint_post_processors';
    if (CACHE_.has(cacheKey)) {
      postProcessors = CACHE_.get(cacheKey);
    }
    else {
      postProcessors = await fetchRobot<RobotEndpointPostProcessor[]>('api/llm/extension/json', 'GET');
      CACHE_.set(cacheKey, postProcessors);
    }
    return ResponseSuccess(postProcessors);
  } catch (error: any) {
    return errorHandler(error);
  }
};
